export const ReviewIcon = (props: any) => (
  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path d='M16.3633 16.4883L21.4984 21.4994' stroke='#ADADAD' strokeWidth='1.5' strokeLinecap='round'
          strokeLinejoin='round' />
    <ellipse cx='10.7162' cy='10.5177' rx='8.21622' ry='8.01772' stroke='white' strokeWidth='1.5' strokeLinecap='round'
             strokeLinejoin='round' />
    <path d='M7 10.5L9.57143 13L15 8' stroke='#ADADAD' strokeWidth='1.5' strokeLinecap='round' />
  </svg>
);
